"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _getDateOfMonth = _interopRequireDefault(require("./getDateOfMonth"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(start, end) {
  var startDate = (0, _getDateOfMonth["default"])(start);
  var diff = (0, _getDateOfMonth["default"])(end) - startDate;

  if (diff >= 0) {
    return diff;
  }

  var daysInLastFullMonth = (0, _dayjs["default"])(end).subtract(1, 'month').daysInMonth();

  if (daysInLastFullMonth < startDate) {
    return diff + startDate;
  }

  return daysInLastFullMonth + diff;
};

exports["default"] = _default;